import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FormHelperService } from "../core/services/form-helper.service";
import { IPaymentModel } from "./payment.model";
import { NgModule, Output, ViewChild, ElementRef } from '@angular/core';
import { PaymentService } from "./payment.service";
import { DateHelperService } from "../core/services/index";
import { DropdownValue } from "../shared/dropdown.model";
import { FieldValidatorService } from "../shared/field-validator-service";
import { PublisherGroupSelectionComponent } from "../shared/publisher-group-selection.component"

@Component({
    moduleId: module.id,
    selector: 'payment-modal',
    templateUrl: 'payment-modal.component.html'
})
export class PaymentModalComponent implements OnInit {
    paymentForm: FormGroup;
    headerText: string = "Create Payment";
    isLoading = false;
    editPayment: IPaymentModel;
    minDate: Date = new Date();
    revenueMonthField: Date;
    paymentDateField: Date;
    statusField: boolean;
    amountField: number;
    publisherGroupIdField: number;
    useLightClass: boolean = false;
    publisherGroupSelectedForEdit: string = "";
    private readonly modalId = "#paymentModal";

    @Output() paymentChanged: EventEmitter<any> = new EventEmitter<Event>();
    @Output() paymentCreated: EventEmitter<any> = new EventEmitter<Event>();

    @ViewChild("publisherGroupSelectorInModal") publisherGroupSelectedItemsComponent: PublisherGroupSelectionComponent

    constructor(private formBuilder: FormBuilder,
        private formHelperService: FormHelperService,
        private paymentService: PaymentService,
        private dateHelperService: DateHelperService,
        private fieldValidatorService: FieldValidatorService,
        private el: ElementRef) {}

    ngOnInit() {
        this.paymentForm = this.formBuilder.group({
            amountField: ['', [Validators.required, this.fieldValidatorService.isValidDecimal]],
            revenueMonthField: ['', []],
            paymentDateField: ['', []],
            statusField: ['', []],
            publisherGroupIdField: ['', [Validators.required]]
        })
    }

    showCreatePayment() {
        this.isLoading = false;
        this.headerText = "Create Payment";
        this.editPayment = null;
        this.publisherGroupSelectedForEdit = "";
        this.paymentForm.reset();
        this.paymentForm.controls["revenueMonthField"].setValue(this.dateHelperService.formatMonthly(new Date()));
        this.statusField = false;
        this.paymentForm.controls["statusField"].setValue(false);
        this.publisherGroupSelectedItemsComponent.setFirstItem();
        $(this.modalId).modal('show');
    }

    showEditPayment(event, item: IPaymentModel) {
        this.isLoading = false;
        event.preventDefault();
        event.stopPropagation();
        this.headerText = "Edit Payment";
        this.editPayment = item;
        this.publisherGroupSelectedForEdit = item.publisherGroupName;
        this.paymentForm.controls["revenueMonthField"].setValue(this.dateHelperService.formatMonthly(item.revenueMonth));
        this.paymentForm.controls["paymentDateField"].setValue(this.dateHelperService.formatDayAndMonth(item.paymentDate));
        this.paymentForm.controls["statusField"].setValue(item.status === 'Paid' ? true : false);
        this.paymentForm.controls["amountField"].setValue(item.amount);
        this.paymentForm.controls["publisherGroupIdField"].setValue(item.publisherGroupId);
        this.publisherGroupSelectedItemsComponent.setCurrentSelection(item.publisherGroupId);
        $(this.modalId).modal('show');
    }

    onSaveChanges(event: any) {
        if (!this.paymentForm.valid)
            return;
        this.isLoading = true;
        if (!this.editPayment) {
            this.paymentService.createPayment(this.publisherGroupIdField, this.paymentForm.value.revenueMonthField, this.paymentForm.value.paymentDateField, this.paymentForm.value.amountField, 
                this.paymentForm.value.statusField).subscribe(() => {
                this.paymentCreated.emit();
                $(this.modalId).modal('hide');
            }, (error: any) => { }, () => { this.isLoading = false; });
        } else {
            this.paymentService.updatePayment(this.editPayment.id, this.editPayment.publisherGroupId, this.paymentForm.value.revenueMonthField, this.paymentForm.value.paymentDateField, 
                this.paymentForm.value.amountField, this.paymentForm.value.statusField).subscribe(() => {
                // parse dates from form in order to be correctly displayed in table through pipes
                let revenueMonthValue = this.dateHelperService.formatDateFromMonthYearString(this.paymentForm.value.revenueMonthField);
                let paymentDateValue = null;
                if (this.paymentForm.value.paymentDateField)
                    paymentDateValue = this.dateHelperService.formatDateFromDayMonthYearString(this.paymentForm.value.paymentDateField);

                this.editPayment.revenueMonth = revenueMonthValue;
                this.editPayment.amount = this.paymentForm.value.amountField;
                this.editPayment.status = this.paymentForm.value.statusField === true ? 'Paid' : 'Unpaid';
                this.editPayment.paymentDate = this.paymentForm.value.statusField === false ? null : paymentDateValue;
                this.paymentChanged.emit();
                $(this.modalId).modal('hide');
            }, (error: any) => { }, () => { this.isLoading = false; });
        }
    }

    showErrorMessage(controlName: string, validator: string): boolean {
        return this.formHelperService.showErrorMessage(this.paymentForm, controlName, validator)
    }

    onPublisherGroupValueChanged(item: DropdownValue) {
        if (item.value === 0) {
            this.publisherGroupIdField = null;
            this.paymentForm.controls["publisherGroupIdField"].setValue(null);
        } else {
            this.publisherGroupIdField = item.value;
            this.paymentForm.controls["publisherGroupIdField"].setValue(item.value);
        }
    }

    public onDateClicked(event) {
        let ng2datePicker = this.el.nativeElement.querySelectorAll("ng2-datetime-picker[draggable='true']");
        $(ng2datePicker).attr('draggable','false');
    }
}


// WEBPACK FOOTER //
// ./src/app/payment/payment-modal.component.ts